import { useMutation } from 'react-query';
import { changeRegisterResultStatus } from 'apis/registerResult.api';

const useChangeRegisterResultStatus = () => useMutation(changeRegisterResultStatus);

export default useChangeRegisterResultStatus;
